module.exports = __webpack_public_path__ + "img/frame (108).15124924.jpg";